import * as Yup from "yup";
import Alert from "../../utils/Alert";
import { addNewPropertyService, editPropertyService } from "../../services/propertiesServices";

export const initialValues = {
    property: "",
    slug: "",
    value: "",
    type: "",
    link: "",
};

export const initialTouched = {
    property: true,
    slug: true,
    value: true,
    type: true,
    link: true,
};

export const onSubmit = async (values, actions, editingProperty, setData, dataLength, itemsCnt, navigate) => {
    if(!values.link) {
        delete values.link;
    }
    try {
        if (editingProperty) {
            const response = await editPropertyService(editingProperty.id, values);
            if (response.status === 200) {
                setData(prevData => prevData.map(d => {
                    if (editingProperty.id === d.id) {
                        return response.data;
                    }
                    return d;
                }));
                Alert("انجام عملیات", "ویژگی با موفقیت ویرایش شد", "success");
                return navigate(-1);
            }
        } else {
            const response = await addNewPropertyService(values);
            if (response.status === 200) {
                if (dataLength < itemsCnt) {
                    setData(prevData => [...prevData, response.data]);
                }
                Alert("انجام عملیات", "ویژگی با موفقیت افزوده شد", "success");
                actions.resetForm();
            }
        }
    } catch (error) {

    }
}

export const validationSchema = Yup.object({
    property: Yup.string().required("لطفاً نام ویژگی را مشخص کنید.")
        .matches(/[^\s]+/, "لطفاً از حروف الفبا و اعداد و نمادها استفاده کنید"),
    slug: Yup.string().required("لطفاً نام ویژگی را مشخص کنید.")
        .matches(/[^\s]+/, "لطفاً از حروف الفبا و اعداد و نمادها استفاده کنید"),
    value: Yup.string().required("لطفاً مقدار ویژگی را مشخص کنید.")
        .matches(/[^\s]+/, "لطفاً از حروف الفبا و اعداد و نمادها استفاده کنید"),
    type: Yup.string().required("لطفاً نوع ویژگی را مشخص کنید.")
        .matches(/[^\s]+/, "لطفاً از حروف الفبا و اعداد و نمادها استفاده کنید"),
    link: Yup.string()
        .matches(/^(http|https):[/]{2}(www\.)?[a-zA-Z0-9.]+\.[a-zA-Z]{2,}([/]{1}[a-zA-Z0-9&#?~=.:_+-]*)*$/, "لطفاً یک آدرس معتبر وارد کنید\nhttps://www.example.com")
});



